module.exports = __webpack_public_path__ + "static/media/montana.af5abdfd.png";